import { DatePipe } from '@angular/common';
import { KentekenValidator } from '../validation/kenteken.validator';

export class FormatHelper {
  static formatDate(datum: Date, format: string): string {
    if (!datum) {
      return '';
    }
    const datePipe = new DatePipe('nl-NL');
    return datePipe.transform(datum, format);
  }

  static formatTime(uren: number, minuten: number): string {
    return this.pad(uren) + ':' + this.pad(minuten);
  }

  static formatDateFromString(dateString: string, format: string): Date {
    if (!dateString || dateString.length < format.length) {
      return null;
    }
    if (dateString.length > format.length) {
      dateString = dateString.substring(0, format.length);
    }
    const formatPattern = /((?:mm?)|(?:dd?)|(?:yyy?y?))[^0-9]((?:mm?)|(?:dd?)|(?:yyy?y?))[^0-9]((?:mm?)|(?:dd?)|(?:yyy?y?))/i;
    const datePattern = /(\d+)[^0-9](\d+)[^0-9](\d+)/i;
    let date = new Date();
    date.setHours(6, 0, 0, 0);

    if (!format) {
      format = 'dd-mm-yyyy';
    }

    var matchFormat = formatPattern.exec(format);
    if (matchFormat) {
      var matchDate = datePattern.exec(dateString);
      if (matchDate) {
        var indexYear = matchFormat.findIndex(function (value) {
          if (value.substring(0, 1) === 'y' && value.length <= 4) { return true; }
        });
        var indexMonth = matchFormat.findIndex(function (value) {
          if (value.substring(0, 1) === 'm' && value.length <= 2) { return true; }
        });
        var indexDay = matchFormat.findIndex(function (value) {
          if (value.substring(0, 1) === 'd' && value.length <= 2) { return true; }
        });

        date.setFullYear(Number(matchDate[indexYear]));
        date.setDate(1); // tijdelijk naar 1, om problemen met 31
        date.setMonth(Number(matchDate[indexMonth]) - 1);
        date.setDate(Number(matchDate[indexDay]));
      }
    }

    return date;
  }

  static formatDatestringFromString(dateString: string, formatIn: string, formatOut: string): string {
    if (!dateString) {
      return '';
    }

    return this.formatDate(this.formatDateFromString(dateString, formatIn), formatOut);
  }

  static stringMetKommas(regels: string[]): string {
    return this.stringMetSeparator(regels, ", ");
  }

  static stringMetSeparator(regels: string[], separator: string): string {
    if (!regels || regels.length < 1) {
      return null;
    }
    if (regels.length === 1) {
      return regels[0];
    }
    let resultaat = "";

    for (let i = 0; i < regels.length; i++) {
      if (regels[i].length > 0) {
        if (resultaat.length > 0) {
          resultaat += separator + regels[i];
        } else {
          resultaat = regels[i];
        }
      }
    }

    return resultaat;
  }

  static formatCurrency(bedrag: number, valutaCode: string): string {
    if (!bedrag && bedrag !== 0) {
      return null;
    }
    // geen valutacode dan default EUR
    if (valutaCode === '' || valutaCode === 'EUR') {
      return '\u20AC' + ' ' + bedrag.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',00', ',-');
    }
    return bedrag.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',00', ',-');
  }

  static formatNumberToString(decimaal: number): string {
    return decimaal.toLocaleString('nl-NL');
  }

  static formatPercentage(perc: number): string {
    return perc.toLocaleString('nl-NL') + '%';
  }

  static firstLetterLower(str: string): string {
    return str ? str.charAt(0).toLowerCase() + str.slice(1) : '';
  }

  static firstLetterUpper(str: string): string {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
  }

  static pad(x: number): string {
    return ((('' + x).length == 2) ? '' : '0') + x;
  }

  static formatKenteken(kenteken: string): string {
    if (kenteken) {
      let geldigKenteken = KentekenValidator.isGeldigKenteken(kenteken);
      if (geldigKenteken.kentekenValid) {
        return geldigKenteken.kentekenOpgemaakt;
      }
    }
    return kenteken;
  }
}
